<template>
  <div class="faq-area pb-100">
    <div class="container mw-1356">
      <div class="row align-items-center">
        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="100"
        >
          <div class="faq-content">
            <span class="top-title">الأسئلة الشائعة</span>
            <h2 class="text-white">كل ما تريد معرفته</h2>
          </div>

          <div class="accordion">
            <div
              class="accordion-item"
              v-for="(item, index) in accordionItems"
              :key="index"
              :class="{ active: activeIndex === index }"
            >
              <h2 class="accordion-header">
                <button
                  class="accordion-button"
                  type="button"
                  :aria-expanded="activeIndex === index ? 'true' : 'false'"
                  @click="toggleAccordion(index)"
                >
                  {{ item.question }}
                </button>
              </h2>
              <div
                class="accordion-collapse collapse show"
                v-show="activeIndex === index"
              >
                <div class="accordion-body">
                  <p>{{ item.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-lg-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-delay="200"
        >
          <div class="faq-img">
            <img src="@/assets/images/faq.png" alt="faq" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FAQ",
  setup() {
    const activeIndex = ref<number>(0);

    const accordionItems = [
      {
        question: "ما هي الأجهزة المدعومة؟",
        answer:
          "تعمل الخدمة على أجهزة Smart TV و Android TV و Fire Stick والهواتف والأجهزة اللوحية والعديد من التطبيقات الشهيرة.",
      },
      {
        question: "كيف أحصل على الدعم الفني؟",
        answer:
          "يمكنك التواصل معنا مباشرة عبر واتساب أو وسائل التواصل المتاحة للحصول على المساعدة.",
      },
      {
        question: "متى يتم تفعيل الاشتراك؟",
        answer:
          "يتم التفعيل خلال وقت قصير بعد إتمام الطلب واستلام بيانات الجهاز.",
      },
      {
        question: "هل يمكنني تجربة الخدمة قبل الاشتراك؟",
        answer:
          "نعم، نوفر تجربة مجانية حتى تتمكن من اختبار الجودة والتأكد من توافق الخدمة مع جهازك.",
      },
      {
        question: "هل تعمل الخدمة خارج بلدي؟",
        answer:
          "نعم، يمكن استخدام الخدمة من أي مكان يتوفر فيه اتصال بالإنترنت.",
      },
    ];

    const toggleAccordion = (index: number) => {
      activeIndex.value = activeIndex.value === index ? -1 : index;
    };

    return {
      activeIndex,
      toggleAccordion,
      accordionItems,
    };
  },
});
</script>